import { BUSCAR_CIDADES_TRECHOS /*, LIMPAR_TRECHOS */ } from '../../actions/types'

const initialState = undefined

export default function reducerBuscarCidadesTrechos (state = [], action = initialState) {
  switch (action.type) {
    case BUSCAR_CIDADES_TRECHOS: {
      const cidades = action.payload.data;

      if (cidades) {
        return cidades
      }
      return []
    }

    default: {
      return state
    }
  }
}
